var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', [_c('div', {
    staticClass: "dot-title",
    style: {
      color: _vm.color
    }
  }, [_vm._v(" 完成 ")]), _vm.isComplete && _vm.result ? [_c('div', {
    staticClass: "dot-tip el-color-gray-7"
  }, [_vm._v(" 导入已完成，其中导入成功" + _vm._s(_vm.result.success) + "条，导入失败" + _vm._s(_vm.result.total - _vm.result.success) + "条 ")]), _c('div', {
    staticClass: "dot-tip el-color-gray-7"
  }, [_vm._v(" 具体结果可查看"), _c('a', {
    staticClass: "link el-color-primary-1",
    attrs: {
      "href": _vm.result.url,
      "target": "_blank"
    }
  }, [_vm._v("下载导入结果")]), _vm._v("进行查看。 ")])] : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };